import { JSXElementConstructor, memo } from "react";
import { Flex } from "../../flex";
import { UserImage, UserImageSize } from "../../user-image";
import * as avatarCss from "./avatar.module.css";

/** Arbiter-compliant Avatar. TODO: doesn't support all variants, sizes, etc. Add as you need. */
export const Avatar = memo(function Avatar({
  name,
  imageUrl,
  alt,
  imageSize = UserImageSize.SMALL,
  DefaultIcon,
  size = "regular",
}: {
  name?: string;
  imageUrl: string | null;
  imageSize?: UserImageSize;
  alt: string;
  DefaultIcon?: JSXElementConstructor<any>;
  size?: "regular" | "large";
}) {
  return (
    <Flex
      align="center"
      className={
        size === "regular"
          ? avatarCss.avatarContainer
          : avatarCss.largeAvatarContainer
      }
      justify="center"
      pt="xs"
    >
      <UserImage
        alt={alt}
        DefaultIcon={DefaultIcon}
        imageUrl={imageUrl}
        name={name}
        size={imageSize}
      />
    </Flex>
  );
});
